import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import "./CustomTimePicker.css";
import { useAccessRights } from "../../../hooks/userPermissions/useAccessRights";
import { getMaxHourForDate } from "../../../utils/weatherTimelineLimits";

const CustomTimePicker = ({
  onChange,
  weatherRequestStartHour,
  weatherRequestDate,
  disabled,
}) => {
  const { getTimelineLimits } = useAccessRights();
  const timelineLimits = getTimelineLimits("weather");
  const intervalMaxJ = timelineLimits?.intervalMaxJ ?? null;
  const maxHour = getMaxHourForDate(weatherRequestDate, intervalMaxJ);
  const isAtMaxHour = weatherRequestStartHour >= maxHour;
  // past 0 would silently desync them (date stays on today while the
  // displayed hour becomes "yesterday 23:00"). Crossing midnight must
  // go through CustomDatePicker instead, so we floor at 0 here.
  const isAtMinHour = weatherRequestStartHour <= 0;

  const incrementDisabled = disabled || isAtMaxHour;
  const decrementDisabled = disabled || isAtMinHour;

  const handleHourChange = (delta) => {
    if (disabled) return;
    if (delta > 0 && isAtMaxHour) return;
    if (delta < 0 && isAtMinHour) return;
    const newHour = weatherRequestStartHour + delta;
    if (onChange) onChange(newHour);
  };

  const formattedTime = `${weatherRequestStartHour
    .toString()
    .padStart(2, "0")}:00`;

  return (
    <div className="time-picker-fr" data-testid="time-picker-fr">
      <div className="time-component">
        <KeyboardArrowUpIcon
          data-testid="time-picker-hour-increment"
          className={`arrow ${incrementDisabled ? "arrow-disabled" : ""}`}
          onClick={() => handleHourChange(1)}
          disabled={incrementDisabled}
          style={{ fontSize: "19px" }}
        />
        <input
          type="text"
          value={formattedTime}
          className={`day-input ${disabled ? "weather-input-disabled" : ""}`}
          readOnly
          disabled={disabled}
        />
        <KeyboardArrowDownIcon
          className={`arrow ${decrementDisabled ? "arrow-disabled" : ""}`}
          onClick={() => handleHourChange(-1)}
          disabled={decrementDisabled}
          style={{ fontSize: "19px" }}
        />
      </div>
    </div>
  );
};

export default CustomTimePicker;